import Api from './api';

const EmailsService = {
    enviar: async (params) => await Api.post(`/email`, (params)),
}

export default EmailsService;